import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { NewTaskModal } from '../newTaskModal';

export const FlowTaskModal = NiceModal.create<{ templateCode: string }>(
  (props) => {
    // props
    const { templateCode } = props;
    // modal
    const { visible, remove } = useModal();
    return (
      <NewTaskModal
        visible={visible}
        templateCode={templateCode}
        onCancel={remove}
      />
    );
  },
);
